import {match} from 'ts-pattern';

import {useEffect} from 'react';

import {onSendEvent, Type} from '@chat/shared/graphql';
import {useTypingState} from '@chat/ui';

import {chatPublicApi} from '../../../api/chatPublicApi';
import {chatAppSync} from '../utils/chatAppSync';

interface UseChatSubscribeProps {
  conversationId: string;
  userId: string;
}

export function useChatSubscribe(props: UseChatSubscribeProps) {
  const {conversationId, userId} = props;

  const [refetchChatHistory] = chatPublicApi.useLazyGetPublicEventsQuery();
  const {isTyping, acknowledgeTyping, resetTypingManual} = useTypingState();

  useEffect(() => {
    if (!conversationId || !userId) {
      return;
    }

    const chatSubscription = chatAppSync
      .graphql({
        query: onSendEvent,
        variables: {conversationId},
      })
      .subscribe({
        next: (event) => {
          if (!event.data) {
            return;
          }

          match(event.data.onSendEvent.type)
            .with(Type.TYPING, () => {
              if (event.data.onSendEvent.userId !== userId) {
                acknowledgeTyping();
              }
            })
            .with(Type.READ, () => refetchChatHistory({conversationId}))
            .otherwise(() => {
              refetchChatHistory({conversationId});
              resetTypingManual();
            });
        },
      });

    return () => {
      chatSubscription.unsubscribe();
    };
  }, [refetchChatHistory, conversationId, acknowledgeTyping, resetTypingManual, userId]);

  return {
    isTyping,
  };
}
